/** @jsx h */
import { h } from 'preact'

import FlagIcon from '../icons/FlagIcon'
import { mapBoxStyleLight } from '../claims/CollaborationCard'
import t from '../../../utils/translate'

const LocationSection = ({ displayName, id, latitude, longitude }) => {
  const coordinates =
    latitude != null ? `[${latitude}, ${longitude}]` : 'unknown'

  return (
    <section class='ModalCard-section'>
      <h3 class='ModalCard-heading'>
        {t('proof_points.js.location.where')}
      </h3>
      <p class='ModalCard-locationText u-marginTop8'>
        <FlagIcon />
        {displayName}
      </p>
      <div
        class='Map ModalCard-map'
        data-controller='map'
        data-map-variant='single'
        data-map-coordinates={coordinates}
        data-map-styleid={mapBoxStyleLight}
      >
        <div
          class='Mapbox-map Mapbox-map--collaboratorCard'
          data-map-target='map'
          id={`Mapbox-map--collaborator-${id}`}
        />
        <div
          class='Mapbox-overlay'
          data-action='click->map#showControls'
          data-map-target='overlay'
        />
      </div>
    </section>
  )
}

LocationSection.defaultProps = {
  latitude: null,
  longitude: null
}

export default LocationSection
